import { ChevronLeft as ChevronLeftIcon } from "@/assets/icons/24/ChevronLeft";
import { cn } from "@/common/utils/css.utils";
import { DialogClose } from "@radix-ui/react-dialog";

type MegaMenuMobileBackProps = {
  className?: string;
};

export const MegaMenuMobileBack = ({ className }: MegaMenuMobileBackProps) => {
  return (
    <DialogClose asChild>
      <button className={cn("shrink-0", className)}>
        <ChevronLeftIcon />
      </button>
    </DialogClose>
  );
};
